module.exports = __webpack_public_path__ + "static/media/warranty.c951959e.png";